<template>
<div>
  <h1 class="section-title m-4 text-center text-lg">クッキーポリシー</h1>
  <div class="p-4 border-b border-section_border bg-white">
  <h2 class="font-bold text-link_darker">1．クッキーについて</h2>
  <p>
    クッキーとは、ウェブサイトをご覧になった際の情報を、使用されたウェブブラウザに記憶させる機能です。
  </p>
  <h2 class="font-bold text-link_darker">2．クッキーの利用目的</h2>
  <p>
    <ol>
      <li>本サイトでは、クッキーを、利用者がウェブサイトを閲覧する際に同じ情報を繰り返し入力することがなくなるなど、利用者の利便性向上のために使用しています。</li>
      <li>本サイトでは、クッキーを使用して収集した情報を利用して、利用者のウェブサイトの利用状況（アクセス状況、トラフィック、ルーティング等）を分析し、ウェブサイト自体のパフォーマンス改善や、提供するサービスの向上、改善のために使用することがあります。</li>
    </ol>
  </p>
  <h2 class="font-bold text-link_darker">3．本サイトで使用しているクッキーについて</h2>
  <p>本サイトでは、以下の種類のクッキーを使用しています。
    <ol>
      <li>必須クッキー<br />
        必須クッキーは、本サイトの利用や本サイトで提供する機能を利用する上で不可欠なクッキーを指し、本サイトを最適に機能させるために使用されます。
      </li>
      <li>パフォーマンスクッキー<br />
        パフォーマンスクッキーは、主に本サイトの利用状況に関する情報を収集します。これらのクッキーは、本サイトの利用者が訪問したページや滞在時間の他、エラーメッセージ等のトラブルの有無など、利用者の通信状況を把握し、本サイトの性能を改善するために使用されます。本サイトでは、Googleアナリティクスをはじめ第三者によって提供されるサービスを利用し、匿名化された利用者の本サイトの利用状況（アクセス状況等）データの統計的な分析のためにこれらのクッキーを使用しています。Google アナリティクスによるデータの取り扱い方法は、Google アナリティクスのヘルプページをご参照ください。（<a href="https://support.google.com/analytics/answer/6004245?hl=ja">データの保護 - アナリティクス ヘルプ (google.com)</a>
      </li>
    </ol>
  </p>
  <h2 class="font-bold text-link_darker">4．クッキーの管理方法</h2>
  <p>
    利用者はブラウザの設定を変更することによりクッキーを無効にすることが可能です。ただし、無効化した場合に本サイトでの動作に影響を及ぼす可能性がありますので、あらかじめご了承ください。クッキーの設定の変更方法については、各ブラウザのヘルプメニューをご参照ください。<br />
    調布市は、このクッキーポリシーを予告なく改定することができるものとします。クッキーポリシーに関する変更は、変更後の内容が当社ウェブサイトに掲載された時点で即時に有効となります。</p>
  <h2 class="font-bold text-link_darker">クッキー利用 同意確認</h2>
  <p>このウェブサイトではサイトの利便性の向上を目的にクッキーを使用します。ブラウザの設定によりクッキーの機能を変更することもできます。詳細はクッキーポリシーをご覧ください。サイトを閲覧いただく際には、クッキーの使用に同意いただく必要があります。</p>
  </div>
  <div class="mt-4">
    <button @click="backTop" class="back_button">
      <span class="w-full -ml-5">戻る</span>
    </button>
  </div>
</div>
</template>
  
  <script>
  
  export default {
    name: 'Policy',
    methods: {
      backTop: function () {
        this.$router.push({ name: 'root', params: { lang: this.lang } })
      }
    }
  }
  </script>
  
<style lang="scss" scoped>

.title{
  display: block;
  font-size: 16px;
  font-style: normal;
  line-height: 130%;
  color: #313234;
}

.message-box{
  display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 12px;
    grid-gap: 6px;
    gap: 6px;
}
.labels {
  display: flex;
  grid-gap: 8px;
  gap: 8px;
}

.article {
  margin: 0 12px;
  display: flex;
  flex-direction: column;
  padding: 20px 16px;
  word-break: break-all;
  border-radius: 8px;
  background-color: #fff;
  grid-gap: 16px;
  gap: 16px;
}

.link{
  color: #2F8DB7;
  font-weight: bold;
  text-decoration: underline;
}
.back_button{
  margin-top: 24px;
  margin-right: 16px;
  margin-left: 16px;
  display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    font-size: 16px;
    height: 52px;
    width: calc(100% - 32px);
    padding: 0 12px;
    text-align: center;
    text-decoration: none;
    box-sizing: border-box;
    border: 1px solid #313234;
    border-radius: 100px;
    background-color: #fff;
    color: #313234;
}
</style>